import script from "./CompanyBlockList.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyBlockList.vue?vue&type=script&setup=true&lang=js"

import "./CompanyBlockList.vue?vue&type=style&index=0&id=8cc127cc&lang=scss"

const __exports__ = script;

export default __exports__